<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <h3 class="page-title">Supervisor dashboard</h3>
            </div>
        </div>
        <div v-if="errorWorkers.length > 0">
            <div class="alert alert-danger" role="alert">
                Workers with error state
            </div>
            <table class="table table-bordered">
                <tr v-for="errorWorker in errorWorkers">
                    <td>{{errorWorker.node}}</td>
                    <td>{{errorWorker.worker}}</td>
                    <td>{{errorWorker.error}}</td>
                </tr>
            </table>
        </div>
        <div class="supervisor-node-info" v-for="(summary, summaryKey) in nodes">
            <div class="row">
                <div class="col">
                    <checkbox-switcher class="view-mode-toggle"
                                       :isChecked="summary.isDetailsExpanded"
                                       labelText="Expaned"
                                       @update:isChecked="(e) => { summary.isDetailsExpanded = e; }"></checkbox-switcher>
                </div>
            </div>
            <div class="row" v-if="!summary.isDetailsExpanded">
                <div class="col">
                    <strong class="node-inline-name">{{summary.node.name}}</strong>
                    <small>
                        workers ({{summary.workersNumber}})
                    </small>
                </div>
            </div>
            <div class="row mt-3" v-if="summary.isDetailsExpanded">
                <div class="col">
                    <table class="table table-bordered" >
                        <tr>
                            <td>Name:</td>
                            <td><strong>{{ summary.node.name }}</strong></td>
                        </tr>
                        <tr>
                            <td>Key:</td>
                            <td><strong>{{ summary.node.key }}</strong></td>
                        </tr>
                        <tr>
                            <td>Active workers:</td>
                            <td><strong>{{ summary.workersNumber }}</strong></td>
                        </tr>
                        <tr>
                            <td>
                                Actions
                            </td>
                            <td>
                                <button type="button" :disabled="summary.node.processing" class="btn btn-danger btn-sm">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                    Restart
                                </button>
                                <button type="button" class="btn btn-info btn-sm" :disabled="summary.node.processing" @click="reloadConfig(summary.node)">
                                    Reload config
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr>
                    <div class="form-group search-group">
                        <label :for="'searchGroup' + summaryKey">Search group:</label>
                        <input type="text" v-model="summary.searchKeyword"
                               :id="'searchGroup' + summaryKey"
                               placeholder="Group name..." class="form-control">
                    </div>
                    <div class="workers-container">
                        <div class="workers-group card mb-2" v-for="group in filteredGroupList(summary)">
                            <div class="group-header card-header">
                                <div :data-target="'#' + group.uid" class="toggle-workers-group" @click="group.collapsed = !group.collapsed">
                                    <b class="group-name">
                                        {{group.name}}
                                    </b>
                                    <small>
                                        running: {{group.running}}/{{group.workerNumber}}
                                    </small>
                                    <div class="btn-group" v-if="$isAdmin()">
                                        <button type="button" @click.stop="stopGroup(summary.node, group)" :disabled="group.processing" class="btn btn-micro btn-light">
                                            Stop all processes
                                        </button>
                                        <button type="button" @click.stop="startGroup(summary.node, group)" :disabled="group.processing" class="btn btn-micro btn-light">
                                            Start all processes
                                        </button>
                                        <button type="button" @click.stop="restartGroup(summary.node, group)" :disabled="group.processing" class="btn btn-micro btn-light">
                                            Restart all processes
                                        </button>
                                    </div>

                                    <i class="fa fa-spinner fa-spin" v-if="group.processing"></i>
                                    <i class="fa fa-pull-right" :class="group.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                                </div>
                            </div>
                            <div class="collapse" :id="group.uid" :class="group.collapsed ? 'show' : ''">
                                <div class="card-body">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Status
                                            </th>
                                            <th>
                                                Description
                                            </th>
                                            <th v-if="$isAdmin()">
                                                Actions
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="worker in group.workers">
                                            <td>
                                                {{ worker.name }}
                                            </td>
                                            <td>
                                                <span class="worker-state" :class="getStateClass(worker.state)">
                                                    {{ worker.statename }}
                                                </span>
                                            </td>
                                            <td>
                                                {{ worker.description }}
                                            </td>
                                            <td v-if="$isAdmin()">
                                                <button type="button" @click.stop="stopWorker(summary.node, worker)"
                                                        :disabled="worker.processing"
                                                        class="btn btn-micro btn-danger">
                                                    Stop worker
                                                </button>
                                                <button type="button" @click.stop="startWorker(summary.node, worker)"
                                                        :disabled="worker.processing"
                                                        class="btn btn-micro btn-success">
                                                    Start worker
                                                </button>
                                                <button type="button"
                                                        @click.stop="restartWorker(summary.node, worker)"
                                                        :disabled="worker.processing"
                                                        class="btn btn-micro btn-warning">
                                                    Restart worker
                                                </button>
                                                <i class="fa fa-spinner fa-spin" v-if="worker.processing"></i>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import CheckboxSwitcher from "../common/checkbox-switcher.vue";

    export default {
        name: 'SupervisorDashboard',
        components: {
            CheckboxSwitcher

        },

        computed: {
            errorWorkers(){
                let errorWorkers = [];
                if(!this.nodes) {
                    return errorWorkers;
                }
                for (let keyNode in this.nodes) {
                    let node = this.nodes[keyNode];

                    let serverName = '';
                    if (typeof node === 'object' && typeof node.node === 'object' && typeof node.node.name !== 'undefined') {
                        serverName = node.node.name;
                    }

                    for (let keyGroup in node.groups) {
                        let workerGroup = node.groups[keyGroup];

                        for (let keyWorker in workerGroup.workers) {
                            let worker = workerGroup.workers[keyWorker];
                            if(worker.statename === 'FATAL') {
                                errorWorkers.push({
                                    node: serverName,
                                    group: worker.group,
                                    worker: worker.name,
                                    error: 'The worker has experienced a serious error.'
                                });
                            } else if(worker.statename === 'RUNNING' && typeof worker.now === 'number' && typeof worker.start === 'number' && Math.floor((worker.now - worker.start) / 60) > 120){
                                errorWorkers.push({
                                    node: serverName,
                                    group: worker.group,
                                    worker: worker.name,
                                    error: 'The worker has not restarted for 2 hours.'
                                });
                            }
                        }
                    }
                }
                return errorWorkers;
            }
        },

        data () {
            return {
                nodes: null
            }
        },

        mounted(){
            this.fetchData();
        },


        methods: {
            fetchData(){
                this.$supervisorService.getSummaryInfo().then(({ data }) => {
                    let nodes = data;
                    nodes.forEach((summary) => {
                        summary = Object.assign(summary, {
                            searchKeyword: "",
                            isDetailsExpanded: true
                        });
                        summary.node.processing = false;

                        for(let key in summary.groups){
                            let workers = this.transformWorkersInfo(summary.groups[key]);

                            summary.groups[key] = {
                                uid: Math.random().toString(36).slice(2),
                                name: key,
                                collapsed: false,
                                workerNumber: Object.keys(workers).length,
                                running: 0,
                                processing: false,
                                workers: workers
                            };
                        }
                    });
                    this.nodes = _.keyBy(nodes, 'node.key');
                    this.updateGroupsSummary();
                });
            },
            filteredGroupList(summaryInfo){
                return _.filter(summaryInfo.groups, (item) => {
                    return !summaryInfo.searchKeyword ||  item.name.toLowerCase().indexOf(summaryInfo.searchKeyword.toLowerCase()) >= 0 ;
                })
            },
            reloadConfig(node){
                node.processing = true;
                this.$supervisorService.reloadConfig(node.key)
                    .then(({data}) => {
                        node.processing = false;
                        let message = [];
                        let needRefresh = false;
                        _.forOwn(data, (value, key) => {
                            message.push(`${_.capitalize(key)}: ${value && value.length ? value.join(', ') : 'none'}`);
                            if(value.length > 0) needRefresh = true;
                        });
                        this.$swal({
                            type: 'info',
                            title: 'Config reloaded',
                            html: message.join('<br/>')
                        });
                        if(needRefresh){
                            this.fetchData();
                        }
                    }).catch((err) => { node.processing = false; this.displayError(err)});
            },
            transformWorkersInfo(workers){
                return _.keyBy(_.map(workers, (i) => {
                    return Object.assign({}, i, { processing: false });
                }), 'name');
            },
            updateGroupsSummary(){
                _.forOwn(this.nodes, (node) => {
                    for(let key in node.groups){
                        let running = _.filter(_.values(node.groups[key].workers), { state: 20}).length;
                        node.groups[key].running = running;
                    }
                });
            },
            restartGroup(node, group){
                group.processing = true;

                this.$supervisorService
                    .restartGroup(node.key, group.name)
                    .then(({data}) =>  {
                        group.processing = false;
                        this.mergeGroupInfo(node, group, data);
                    }).catch((err) => { group.processing = false; this.displayError(err)});
            },

            startGroup(node, group){
                group.processing = true;
                this.$supervisorService.startGroup(node.key, group.name).then(({data}) =>  {
                    group.processing = false;
                    this.mergeGroupInfo(node, group, data);
                }).catch((err) => { group.processing = false; this.displayError(err)});
            },

            stopGroup(node, group){
                group.processing = true;
                this.$supervisorService.stopGroup(node.key, group.name).then(({data}) =>  {
                    group.processing = false;
                    this.mergeGroupInfo(node, group, data);
                }).catch((err) => { group.processing = false; this.displayError(err)});
            },

            startWorker(node, worker){
                this.setWorkerProcessing(node, worker, true);
                this.$supervisorService.startWorker(node.key, worker.group, worker.name).then(({data}) =>  {
                    this.mergeWorkerInfo(node, data);
                    this.setWorkerProcessing(node, worker, false);
                }).catch((err) => {
                    this.setWorkerProcessing(node, worker, false);
                    this.displayError(err);
                });
            },

            stopWorker(node, worker){
                this.setWorkerProcessing(node, worker, true);
                this.$supervisorService.stopWorker(node.key, worker.group, worker.name).then(({data}) =>  {
                    this.mergeWorkerInfo(node, data);
                    this.setWorkerProcessing(node, worker, false);
                }).catch((err) => {
                    this.setWorkerProcessing(node, worker, false);
                    this.displayError(err);
                });
            },

            restartWorker(node, worker){
                this.setWorkerProcessing(node, worker, true);
                this.$supervisorService.restartWorker(node.key, worker.group, worker.name).then(({data}) =>  {
                    this.setWorkerProcessing(node, worker, false);
                    this.mergeWorkerInfo(node, data);
                }).catch((err) => {
                    this.setWorkerProcessing(node, worker, false);
                    this.displayError(err);
                });
            },

            mergeWorkerInfo(node, worker){
                let path = [node.key, 'groups', worker.group, 'workers', worker.name].join('.');

                if(_.has(this.nodes, path)){
                    let current = this.nodes[node.key].groups[worker.group].workers[worker.name];
                    this.nodes[node.key].groups[worker.group].workers[worker.name] = Object.assign({}, current, worker);
                }
                this.updateGroupsSummary();
            },

            mergeGroupInfo(node, group, newData){
                let originalNode = this.nodes[node.key];
                let originalGroup = originalNode.groups[group.name];
                originalGroup.workers = _.merge({}, originalGroup.workers, this.transformWorkersInfo(newData));
                this.updateGroupsSummary();
            },

            displayError(error){
                this.$swal({
                    type: 'error',
                    title: 'An error occurred',
                    text: error.faultString
                });
                console.error(error);
            },

            setWorkerProcessing(node, worker, status){
                let path = [node.key, 'groups', worker.group, 'workers', worker.name].join('.');
                if(_.has(this.nodes, path)){
                    this.nodes[node.key].groups[worker.group].workers[worker.name].processing = status;
                }
            },

            getStateClass(state){
                let map = {
                    '0': 'worker-stopped',
                    '10': 'worker-starting',
                    '20': 'worker-running',
                    '30': 'worker-backoff',
                    '40': 'worker-stopping',
                    '100': 'worker-exited',
                    '200': 'worker-stopped',
                    '1000': 'worker-unknown',
                };

                return map.hasOwnProperty(state) ? map[state] : map['1000'];
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .supervisor-node-info{
        margin-bottom: 20px;
        padding: 10px;
        border: 1px solid #bbb;
        border-radius: 5px;
        background: #fbfbfb;
        .table{
            background: #fff;
        }
    }

    .toggle-workers-group{
        display: block;
        text-decoration: none;
        color: #444;
        i.fas{
            line-height: 24px;
        }
    }

    .workers-group{
        .group-header{
            background: #fff;
        }
    }

    .worker-state{
        padding: 2px 3px;
        border-radius: 5px;
        font-size: 12px;
        color: #fff;
        &.worker-running{
            background: #49de1e;
        }
        &.worker-stopped{
            background: #bbb;
        }
    }
    .workers-container{
        max-height: 350px;
        overflow-y: auto;
    }
    .search-group{
        border: 1px solid #bbb;
        padding: 10px;
    }
    .node-inline-name{
        color: #101010;
        border-bottom: 1px solid;
        padding: 5px;
    }

    .view-mode-toggle{
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/supervisor/dashboard.vue